import styled from 'styled-components';
import IconVideo from '@catalogo/ui-americanas-desktop-svg/icon-video.svg';

export const Icon = styled(IconVideo)`
  width: 30%;
  height: 30%;
  color: white;
  cursor: pointer;
`;
